export const WIZARD_STEPS = {
    RESUMEN: 1,
    DATOS_COMPRADOR: 2,
    SELECTOR_GATEWAY: 3,
    METODO_PAGO: 4,
    COMPLETADO: 5,
} as const;

export type WizardStep = typeof WIZARD_STEPS[keyof typeof WIZARD_STEPS];

export const COMPRA_STATUS = {
    PENDIENTE: 'pendiente',
    EN_PROCESO: 'en proceso',
    CONFIRMADA: 'confirmada',
    RECHAZADA: 'rechazada',
} as const;

export type CompraStatus = typeof COMPRA_STATUS[keyof typeof COMPRA_STATUS];

export const COMPRA_STATUS_CONFIG = {
    [COMPRA_STATUS.CONFIRMADA]: {
        message: 'Compra confirmada',
    },
    [COMPRA_STATUS.RECHAZADA]: {
        message: 'No pudimos procesar tu compra',
    },
    [COMPRA_STATUS.PENDIENTE]: {
        message: 'Procesando tu compra...',
    },
    [COMPRA_STATUS.EN_PROCESO]: {
        message: 'Procesando tu compra...',
    },
} as const;

export const COMPRA_MESSAGES = {
    TIMEOUT: 'El tiempo de espera para confirmar el pago ha expirado. Si realizaste el pago, contacta a soporte.',
} as const;

export const STEPS_WITH_TIMER: readonly WizardStep[] = [
    WIZARD_STEPS.DATOS_COMPRADOR,
    WIZARD_STEPS.SELECTOR_GATEWAY,
    WIZARD_STEPS.METODO_PAGO
];
